/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_SortInputs */

const en_qk_sort = /** @type {(inputs: Qk_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order of the results`)
};

const de_qk_sort = /** @type {(inputs: Qk_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge der Ergebnisse`)
};

/**
* | output |
* | --- |
* | "Order of the results" |
*
* @param {Qk_SortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_sort = /** @type {((inputs?: Qk_SortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_SortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_sort(inputs)
	return en_qk_sort(inputs)
});